export const AT = {
  SET_ALERT: "SET_ALERT",
  SET_USER: "SET_USER",
  SET_ISOCODE: "SET_ISOCODE",
  SET_PROVIDER: "SET_PROVIDER",
  SET_SETTINGS: "SET_SETTINGS",
};
